<template>
    <div class="container-fluid py-4">
      <template v-if="!isLoading">
        <div class="d-flex flex-wrap justify-content-between align-items-center gap-3 mb-4 pb-3 border-bottom">
          <h4 class="text-dark mb-0">Detalles del Trabajador</h4>
          <div class="d-flex flex-wrap gap-2">
            <template v-if="readOnly">
              <button @click="readOnly = false" class="btn btn-info mb-0">Editar Registro</button>
            </template>
            <template v-else>
              <button @click="readOnly = true" class="btn btn-secondary mb-0">Descartar</button>
              <button @click.stop="update" class="btn btn-success mb-0">Guardar</button>
            </template>
            <button @click.stop="deleteCustomer" class="btn btn-danger mb-0">Eliminar</button>
          </div>
        </div>
        <div class="row d-flex">
          <div class="col-xs-12 col-lg-4">
            <div class="mb-3">
              <label class="form-label text-primary">Nombre</label>
              <input type="text" class="form-control" v-model="customer.name" :disabled="readOnly">
            </div>
          </div>
          <div class="col-xs-12 col-lg-4">
            <div class="mb-3">
              <label class="form-label text-primary">Matrícula</label>
              <input type="text" class="form-control" v-model="customer.matricula" :disabled="readOnly">
            </div>
          </div>
          <div class="col-xs-12 col-lg-4">
            <div class="mb-3">
              <label class="form-label text-primary">Área/supervisor</label>
              <input type="text" class="form-control" v-model="customer.area" :disabled="readOnly">
            </div>
          </div>
          <div class="col-xs-12 col-lg-4">
            <div class="mb-3">
              <label class="form-label text-primary">Email</label>
              <input type="text" class="form-control" v-model="customer.email" :disabled="readOnly">
            </div>
          </div>

          <div class="col-xs-12 col-lg-4">
            <div class="mb-3">
              <label class="form-label text-primary">Telefono</label>
              <input type="text" class="form-control" v-model="customer.phone" :disabled="readOnly">
            </div>
          </div>
          <div class="col-xs-12 col-lg-4">
            <div class="mb-3">
              <label class="form-label text-primary">Dirección 1</label>
              <input type="text" class="form-control" v-model="customer.address_1" :disabled="readOnly">
            </div>
          </div>
          <div class="col-xs-12 col-lg-4">
            <div class="mb-3">
              <label class="form-label text-primary">Dirección 2</label>
              <input type="text" class="form-control" v-model="customer.address_2" :disabled="readOnly">
            </div>
          </div>
          <h5>Hijos(a)</h5>
            
                <table class="table table-bordered schedule">
                <thead>
                    <tr>
                        <th>Nombre</th>
                        <th>Edad</th>
                        <th>Equipo</th>
                        <th>Nivel</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-if="customer.youths.length > 0">
                        <tr 
                            v-for="(youth,index) in customer.youths"
                            :key="index"  
                        >
                            <td>
                                <a :href="`/recreativo-juvenil/${youth.id}`">
                                    {{ youth.first_name }} {{ youth.last_name  }}
                                </a>
                            </td>
                            <td>{{ youth.age }}</td>
                            <td>{{ youth.teams[0]?.name }}</td>
                            <td>{{ youth.teams[0]?.level }}</td>
                        </tr>
                    </template>
                    <template v-if="customer.infants.length > 0">
                        <tr 
                            v-for="(infant,index) in customer.infants"
                            :key="index"  
                        >
                            <td>
                                <a :href="`/recreativo-infantil/${infant.id}`">
                                    {{ infant.first_name }} {{ infant.last_name  }}
                                </a>
                                
                            </td>
                            <td>{{ infant.age }}</td>
                            <td>{{ infant.teams[0]?.name }}</td>
                            <td>{{ infant.teams[0]?.level }}</td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>
      </template>

      <template v-else>
        <p>Cargando datos...</p>
      </template>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  const PUBLIC_API_URL = process.env.VUE_APP_PUBLIC_API_URL;
  export default {
    name: 'CustomerDetails',
    data() {
      return {
        customer: null,
        isLoading: false,
        readOnly: true,
      };
    },
    created() {
      this.fetchCustomerDetails();
    },
    methods: {
      async fetchCustomerDetails() {
        this.isLoading = true;
        const id = this.$route.params.id;
    
        try {
          const response = await axios.get(`${PUBLIC_API_URL}/customers/${id}`);
          console.log('response: ',response.data)
          this.customer = response.data;
            
        } catch (error) {
          console.error("Hubo un error al obtener los detalles del trabajador:", error);

        }
        
        this.isLoading = false;
      },
      async update(){
        
        this.isLoading = true;
        try {
          
          const response = await axios.put(`${PUBLIC_API_URL}/customers/${this.customer.id}`, this.customer);
          console.log('response: ',response.data)
          this.fetchCustomerDetails()
          this.readOnly = true
          this.$swal({
            title: "Actualizado con Exito!",
            text: "Los datos del trabajador fueron actualizados!",
            icon: "success"
          });
        } catch (error) {
          this.$swal({
            title: "Ocurrio un error!",
            text: "No pudimos actualizar los datos del trabajador!",
            icon: "error"
          });
        }
      },
      async deleteCustomer(){
        const result = await this.$swal({
          title: "¿Eliminar padre/trabajador?",
          text: "Se eliminará también a todos sus hijos(as) registrados. Esta acción no se puede deshacer.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Sí, eliminar",
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#dc3545",
        });

        if (!result.isConfirmed) return;

        try {
          await axios.delete(`${PUBLIC_API_URL}/customers/${this.customer.id}`);
          this.$swal({
            title: "Eliminado con Éxito!",
            text: "El trabajador y sus hijos(as) fueron eliminados.",
            icon: "success"
          });
          this.$router.push('/trabajadores');
        } catch (error) {
          this.$swal({
            title: "Ocurrio un error!",
            text: "No pudimos eliminar al trabajador!",
            icon: "error"
          });
        }
      },

    }
  };
  </script>
  
  <style scoped>

  </style>
  